<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
    </div>

    <v-flex xs12>
      <v-card class="mb-3">
        <v-card-text>
          <v-row align="center">
            <v-col cols="1" class="text-center">
              <v-icon x-large color="primary">mdi-bug-outline</v-icon>
            </v-col>
            <v-col>
              <div class="title primary--text mb-2">
                Reportar un error
              </div>
              <div>
                Si te encuentras con algún error dentro de eato.mx que te impida hacer tu trabajo, repórtalo con nosotros y con gusto lo solucionaremos lo más pronto posible.
              </div>
            </v-col>
            <v-col cols="3">
              <div class="d-flex justify-end">
                <v-btn
                  text
                  color="primary"
                  :to="{ name: 'BugSupport' }">
                  Ir a reportar un bug
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="mb-3">
        <v-card-text>
          <v-row align="center">
            <v-col cols="1" class="text-center">
              <v-icon x-large color="primary">mdi-laptop</v-icon>
            </v-col>
            <v-col>
              <div class="title primary--text mb-2">
                Sugiere una nueva funcionalidad
              </div>
              <div>
                ¿Te gustaría que agregaramos alguna funcionalidad para ayudarte a hacer el trabajo más facil?<br>
                Dinos cuál es esa funcionalidad que te gustaría que tuviéramos.
              </div>
            </v-col>
            <v-col cols="3">
              <div class="d-flex justify-end">
                <v-btn
                  text
                  color="primary"
                  :to="{ name: 'FunctionalitySupport' }">
                  Sugerir funcionalidad
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="mb-3">
        <v-card-text>
          <v-row align="center">
            <v-col cols="1" class="text-center">
              <v-icon x-large color="primary">mdi-message-text</v-icon>
            </v-col>
            <v-col>
              <div class="title primary--text mb-2">
                Chatea con nosotros
              </div>
              <div>
                ¿Necesitas una atención más personal?<br>
                Chatea con nosotros o si no estamos disponibles déjanos un mensaje y te conestaresmos tus dudas a la brevedad.
              </div>
            </v-col>
            <v-col cols="3">
              <div class="d-flex justify-end">
                <v-btn
                  text
                  color="primary"
                  @click="openChat">
                  Abrir chat
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      section: '¿En qué te podemos ayudar?'
    }
  },
  methods: {
    openChat () {
      window.open(
        'https://tawk.to/chat/5fa9651a0a68960861bd3712/default',
        'Chat eato',
        'height=500,width=500'
      )
    }
  }
}
</script>
